import { render, staticRenderFns } from "./ReleaseNoteDialog.vue?vue&type=template&id=fbc641be"
import script from "./ReleaseNoteDialog.vue?vue&type=script&lang=js"
export * from "./ReleaseNoteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports